<template>
  <button class="t-tab-navbutton" :class="classes" @click="handleClick" />
</template>

<script>
export default {
  name: 't-tab-navbutton',
  props: {
    right: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        't-tab-navbutton--start': this.right === false,
        't-tab-navbutton--end': this.right,
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.t-tab-navbutton {
  background: transparent;
  border: 0;
  cursor: pointer;
  display: block;
  height: 100%;
  padding: 0;
  position: absolute;
  top: 0;
  transition: opacity 0.2s;
  width: 48px;
  z-index: 1000;

  &::before {
    --arrow-border-width: 2px;
    --arrow-size: 10px;
    border: 0 solid var(--track-color-bluegray-80);
    content: "";
    display: block;
    height: var(--arrow-size);
    transform: rotate(45deg);
    width: var(--arrow-size);
    margin: 0 auto;
  }

  &.t-tab-navbutton--start {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );

    left: 0;

    &::before {
      border-width: 0 0 var(--arrow-border-width) var(--arrow-border-width);
    }
  }

  &.t-tab-navbutton--end {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 1) 100%
    );
    right: 0;

    &::before {
      border-width: var(--arrow-border-width) var(--arrow-border-width) 0 0;
    }
  }
}
</style>
